import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";

import AppWrapper from "./AppWrapper";

/** contexts */
import { SettingsProvider } from "./context/settings";
import { UsersProvider } from "./context/users";

import reportWebVitals from "./reportWebVitals";

/** services */
import client from "./../src/services/graphql";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    {/* <HashRouter> */}
    <BrowserRouter>
      <ApolloProvider client={client}>
        <UsersProvider>
          <SettingsProvider>
            <AppWrapper />
          </SettingsProvider>
        </UsersProvider>
      </ApolloProvider>
    </BrowserRouter>
    {/* </HashRouter> */}
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
